import { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { Link, Stack, SvgIcon, Tab, Tabs, Typography } from '@mui/material';
import { Customer } from '@/models/customer';
import ArrowLeftIcon from '@heroicons/react/24/solid/ArrowLeftIcon';
import { FlexContainer } from '@/components/Layout/Container';
import { TabContext, TabPanel } from '@mui/lab';
import { CustomerData } from '@/pageContents/customers/details/CustomerData';
import { CustomerKeycardsList } from '@/pageContents/customers/details/CustomerKeycardsList';
import { CustomerOrdersList } from '@/pageContents/customers/details/CustomerOrdersList';
import { CustomerDetailsMails } from '@/pageContents/customers/details/CustomerDetailsMails';
import { useSearchParams } from 'react-router-dom';

type CustomerDetailsContentProps = {
    customer: Customer;
};

export const CustomerDetailsContent: FunctionComponent<
    CustomerDetailsContentProps
> = ({ customer }) => {
    const [searchParams] = useSearchParams();
    const tab = searchParams.get('tab');

    const [tabValue, setTabValue] = useState((tab as string) || 'customer');

    const handleTabChange = useCallback((_, newValue: string) => {
        setTabValue(newValue);
    }, []);

    useEffect(() => {
        const query = new URLSearchParams();

        query.set('tab', tabValue);
        window.history.replaceState(
            null,
            '',
            `${window.location.origin}${
                window.location.pathname
            }?${query.toString()}`
        );
    }, [tabValue]);

    return (
        <TabContext value={tabValue}>
            <Stack
                sx={{
                    height: '100px',
                }}
                spacing={3}
            >
                <Link
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        color: 'text.primary',
                    }}
                    href='/kunden'
                >
                    <SvgIcon
                        fontSize='small'
                        sx={{
                            mr: 2,
                        }}
                    >
                        <ArrowLeftIcon />
                    </SvgIcon>

                    <Typography variant='subtitle2' component='span'>
                        Kunden
                    </Typography>
                </Link>

                <Stack spacing={6}>
                    <FlexContainer
                        sx={{ borderBottom: 1, borderColor: 'divider' }}
                    >
                        <Tabs value={tabValue} onChange={handleTabChange}>
                            <Tab label='Kunde details' value='customer' />
                            <Tab
                                label='Keycards und Tickets'
                                value='keycards'
                            />
                            <Tab label='Bestellungen' value='orders' />

                            <Tab label='Mails' value='mails' />
                        </Tabs>
                    </FlexContainer>
                    <TabPanel value='customer'>
                        <CustomerData customer={customer} />
                    </TabPanel>
                    <TabPanel value='keycards'>
                        <CustomerKeycardsList customer={customer} />
                    </TabPanel>
                    <TabPanel value='orders'>
                        <CustomerOrdersList customer={customer} />
                    </TabPanel>

                    <TabPanel value='mails'>
                        <CustomerDetailsMails customer={customer} />
                    </TabPanel>
                </Stack>
            </Stack>
        </TabContext>
    );
};
